import { LOGIN_URL } from './links';

// Google Analytics events (README "Analytics"). window.gtag exists only when
// the build has a Measurement ID and the page is on a diligenshub.com host
// (public/index.html), so everywhere else these do nothing.
//   generate_lead  the Request Information form was sent (RequestInfoPage)
//   cta_click      a button or arrow link in the page (Actions, TextLink in
//                  Sections.jsx): { label, page }
//   login_click    any link to the app's sign-in: { page }
//   mailto_click   any email link: { page, address }
export const track = (name, params) => window.gtag?.('event', name, params);

export const trackCta = (label) => track('cta_click', { label, page: window.location.pathname });

// One listener for every link on the page (App.js), so Log In and email
// links count wherever they are: header, footer, copy or the status frame.
export const trackLinkClick = (event) => {
  const link = event.target.closest?.('a[href]');
  if (!link) return;
  const href = link.getAttribute('href');
  const page = window.location.pathname;
  if (href.startsWith(LOGIN_URL)) track('login_click', { page });
  else if (href.startsWith('mailto:')) track('mailto_click', { page, address: href.slice('mailto:'.length) });
};
